'use es6';

import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import SidebarCardError from 'customer-data-sidebar/SidebarCardError';
import Loadable from 'UIComponents/decorators/Loadable';
import AsyncComponentErrorHandler from './AsyncComponentErrorHandler';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingComponent = () => /*#__PURE__*/_jsx(UIFlex, {
  align: "center",
  justify: "center",
  className: "relative",
  style: {
    height: 250
  },
  children: /*#__PURE__*/_jsx(UILoadingOverlay, {
    contextual: true
  })
});
export function makeAsyncCard({
  chunkName,
  loader
}) {
  const handleError = AsyncComponentErrorHandler(chunkName);
  let retries = 1;
  return Loadable({
    loader,
    LoadingComponent,
    ErrorComponent: ({
      error,
      retry
    }) => {
      handleError(error);
      if (retries > 0) {
        retry();
        retries -= 1;
        return /*#__PURE__*/_jsx(LoadingComponent, {});
      } else {
        return /*#__PURE__*/_jsx(SidebarCardError, {});
      }
    }
  });
}